// src/index.ts
import "./class-component-hooks"; // leave it here

import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import i18n from "./lang/i18n";
import Vuelidate from "vuelidate";
import store from "./vuex/store";
import Alerts from "./plugins/alerts/alert";
import BreadCrumb from "./components/shared/BreadCrumb.vue";
import BreadCrumbNew from "./components/shared/BreadCrumbNew.vue";
import NavPills from "./components/shared/NavPills.vue";
import Favorite from "./components/shared/Favorite.vue";
import Selector from "./components/shared/Selector.vue";
import vSelect from "vue-select";
import NumericInput from "./components/shared/NumericInput.vue";
import Vue2Filters from "vue2-filters";
import Snotify, { SnotifyPosition } from "vue-snotify";
import { SnotifyService } from "vue-snotify/SnotifyService";
// Element configuration
import { DatePicker, Tag } from "element-ui";
import VueCookies from "vue-cookies";

declare module "vue/types/vue" {
  interface Vue {
    $snotify: SnotifyService;
  }
}
import configureInstana from "./utils/instana";
import cc from "iso-currencies";

// Styles (Bootstrap and custom)
import "bootstrap/dist/css/bootstrap.css";
import ElementUI from "element-ui";
import "./assets/css/styles.css";
import AddressFilter from "./filters/AddressFilter";
import DateFilter from "./filters/DateFilter";
import DateTimeFilter from "./filters/DateTimeFilter";
import TimeFilter from "./filters/TimeFilter";
import { getDatePickerOptions, elDatePickerFormat } from "./services/Helpers";
import { filterSelectBy } from "@/plugins/vue-select/selectHelpers";

Vue.config.productionTip = false;

import "./directives/onedecimal";
import "./directives/twodecimals";
import "./directives/InputMinMax";
import numbro from "numbro";
import Keycloak from "keycloak-js";
const languageGB = require("numbro/dist/languages/en-GB.min.js");
const languageIT = require("numbro/dist/languages/it-IT.min.js");
numbro.registerLanguage(languageGB);
numbro.registerLanguage(languageIT);
const host = window.location.hostname;
let KEYCLOAK_HOST = "";
let BASE_API_URL = "";
let BASE_HUB_URL = "";
if (host.includes("localhost") === true) {
  BASE_API_URL = process.env.VUE_APP_BASE_API_URL;
  KEYCLOAK_HOST = "https://oauth.dev.mbehub.cloud.mbeglobal.io";
  BASE_HUB_URL = "https://www.dev.mbehub.cloud.mbeglobal.io";
} else if (host.includes("www-online-")) {
  BASE_HUB_URL = "https://" + host.replace("www-online-", "www-"); //DYNAMIC
  BASE_API_URL = "https://" + host.replace("www-online-", "api-");
  KEYCLOAK_HOST = "https://" + host.replace("www-online-", "oauth-");
} else if (host.includes(".dev")) {
  BASE_HUB_URL = "https://" + host.replace("www.online", "www"); //DEV
  BASE_API_URL = "https://" + host.replace("www.online", "api");
  KEYCLOAK_HOST = "https://" + host.replace("www.online", "oauth");
} else if (host.includes(".demo")) {
  BASE_HUB_URL = "https://" + host.replace(".mbeonline", ".mbehub"); //DEMO
  BASE_API_URL = "https://" + host.replace("www.", "api.");
  KEYCLOAK_HOST = "https://oauth.demo.mbe-hub.com";
} else {
  BASE_HUB_URL = "https://" + host.replace(".mbeonline", ".mbehub"); //PROD
  BASE_API_URL = "https://" + host.replace("www.", "api.");
  KEYCLOAK_HOST = "https://oauth.mbe-hub.com";
}
store.commit("updateBASE_API_URL", BASE_API_URL);
store.commit("updateBASE_HUB_URL", BASE_HUB_URL);
let BASE_QAPLA_URL = "";
//this if is needed in the case MBE LAB sets a different website for dev
if (store.getters.envs.isDev) {
  BASE_QAPLA_URL = "https://dev-cp.eship.mbeglobal.com";
} else if (
  store.getters.envs.isPreProduction ||
  store.getters.envs.isIntegration
) {
  BASE_QAPLA_URL = "https://staging-cp.eship.mbeglobal.com";
} else {
  BASE_QAPLA_URL = "https://eship.mbeglobal.com";
}
store.commit("updateBASE_QAPLA_URL", BASE_QAPLA_URL);

Vue.use(Vuelidate);
Vue.use(Alerts);
Vue.use(Vue2Filters);
Vue.use(VueCookies);

// Notifications setup
const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    timeout: 5000,
    //showProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false
  }
};

const KEYCLOAK_BASE_API_URL = KEYCLOAK_HOST + "/realms/mbe-hub";
store.commit("updateKEYCLOAK_BASE_API_URL", KEYCLOAK_BASE_API_URL);

const kcOptions = {
  url: KEYCLOAK_HOST,
  realm: "mbe-hub",
  clientId: "mbe-mol-fe"
};

export const _keycloak = new Keycloak(kcOptions);

_keycloak.init({
  checkLoginIframe: false,
  enableLogging: true
});

Vue.use(Snotify, options);

Vue.use(DatePicker);
Vue.use(Tag);
Vue.use(ElementUI, {
  i18n: (key: any, value: any) => i18n.t(key, value)
});
Vue.component("MbeBreadCrumb", BreadCrumb);
Vue.component("MbeBreadCrumbNew", BreadCrumbNew);
Vue.component("MbeNavPills", NavPills);
Vue.component("vSelect", vSelect);
Vue.component("MbeFavorite", Favorite);
Vue.component("MbeSelector", Selector);
Vue.component("MbeNumericInput", NumericInput);
Vue.filter("date", DateFilter);
Vue.filter("dateTime", DateTimeFilter);
Vue.filter("time", TimeFilter);
Vue.filter("addressDisplay", AddressFilter);

Vue.mixin({
  computed: {
    datePickerDateFormat: () => elDatePickerFormat(),
    getDatePickerOptions: () => getDatePickerOptions(),
    filterSelectBy: () => filterSelectBy,
    mbeCurrencyISO: () => store.getters.currency,
    mbeCurrencyName: () => cc.information(store.getters.currency).name,
    mbeCurrencySymbol: () => cc.information(store.getters.currency).symbol
  }
});

configureInstana(router);
// MAIN VUE OBJECT
new Vue({
  el: "#app",

  router,
  i18n,
  store,

  template: `<App/>`,
  components: {
    App
  },
  validations: {},

  render: h =>
    h(App, {
      props: {}
    })
});

if (store.state.currentLogin.initialized === false) {
  store.dispatch("afterTokenStored"); //back compatibility patch
}
